import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogClose, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '@modules/shared.module';

@Component({
  selector: 'app-button-close-dialog',
  standalone: true,
  imports: [MatButtonModule,MatIconModule,MatDialogModule,MatDialogClose],
  template: `<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="default">close</mat-icon>
</button>
`,
  styleUrls: ['./button-close-dialog.component.css'],
})
export class ButtonCloseDialogComponent { }
